import React from 'react';
import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';
import { sanitizeHTML } from '../../../utils/sanitizeHTML';
import { getMediaTitle } from '../timeline/SessionTimelineContent';
import SectionMediaThumbnail from '../timeline/SectionMediaThumbnail';
import { Section, Segment } from '../models/timeline';
import {
  PrintMediaSlideContainer,
  VideoSectionContainer,
  FONT_SIZE_SCALE,
  BodyContentContainer,
} from './PrintElements';
import Script from './Script';
import Supplies from './Supplies';
import Tip from './Tip';
import { PrintPreferences } from './PrintableTimeline';

const SectionContainer = styled.div<{ includeMedia: boolean }>`
  margin-bottom: ${Grid._3};
  margin-left: ${Grid._3};
  margin-right: ${Grid._3};

  display: flex;
  flex-direction: column;
  gap: ${Grid._3};

  ${({ includeMedia }) =>
    includeMedia &&
    `
      flex-direction: row;
    `}
`;

const PrintMediaSlideItem = styled(SectionMediaThumbnail)`
  margin: 0;
`;

const showMedia = (section: Section, printPreferences: PrintPreferences) => {
  return (!!section.media || section._type === 'video') && printPreferences.media;
};

type SectionTypeMap = {
  tip: { tipType: Record<string, string> };
  video: { iconClass: string };
};

type PrintSectionProps = {
  section: Section;
  segment: Segment;
  printPreferences: PrintPreferences;
  sectionTypeMap: SectionTypeMap;
};

export default function PrintSection({ section, segment, printPreferences, sectionTypeMap }: PrintSectionProps) {
  return (
    <SectionContainer includeMedia={showMedia(section, printPreferences)}>
      {section._type === 'tip' && (
        <Tip
          text={section.text ?? ''}
          tipType={sectionTypeMap.tip.tipType[section.tipType as keyof typeof sectionTypeMap.tip.tipType]}
          fontSize={printPreferences.fontSize}
        />
      )}
      {section._type === 'video' && (
        <VideoSectionContainer fontSize={printPreferences.fontSize}>
          <i className={sectionTypeMap['video'].iconClass}></i>
          <h5>Presentation</h5>
          <p>Play {getMediaTitle(section, segment)}</p>
        </VideoSectionContainer>
      )}
      {section._type === 'body' && (
        <BodyContentContainer fontSize={printPreferences.fontSize}>
          <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(section.text ?? '') }} />
        </BodyContentContainer>
      )}
      {section._type === 'supplies' && (
        <Supplies supplies={section.supplies ?? []} fontSize={printPreferences.fontSize} />
      )}
      {section._type === 'script' && <Script text={section.text ?? ''} fontSize={printPreferences.fontSize} />}
      {showMedia(section, printPreferences) && (
        <PrintMediaSlideContainer>
          <PrintMediaSlideItem
            media={section.media}
            title={getMediaTitle(section, segment)}
            onClick={() => {}}
            viewOnly
          />
        </PrintMediaSlideContainer>
      )}
    </SectionContainer>
  );
}
